import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";

const rp = (n) => "Rp" + (n == null ? "0" : Math.round(n).toLocaleString("id-ID"));

function K({ label, value, tone }) {
  return <Card className="p-3 bg-slate-900 border-slate-800"><div className="text-xs text-slate-400">{label}</div><div className={`text-xl font-semibold ${tone || "text-white"}`}>{value}</div></Card>;
}

export default function HrDashboard() {
  const { can } = useAuth();
  const isOwner = can("dashboard.owner");
  const [d, setD] = useState(null);
  const [o, setO] = useState(null);
  useEffect(() => {
    api.get("/hr/dashboard").then((r) => setD(r.data)).catch((e) => toast.error(apiError(e)));
    if (isOwner) api.get("/hr/owner-summary").then((r) => setO(r.data)).catch(() => {});
  }, [isOwner]);
  if (!d) return <div className="p-6 text-slate-400">Memuat…</div>;
  const p = d.payroll_current;
  return (
    <div className="p-6" data-testid="hr-dashboard-page">
      <h1 className="text-2xl font-semibold text-white mb-1">Dashboard HR</h1>
      <p className="text-slate-400 text-sm mb-4">Ringkasan SDM · {d.date}</p>
      {isOwner && o && (
        <Card className="p-4 bg-slate-900 border-slate-800 mb-4" data-testid="owner-hr-summary">
          <h3 className="text-white font-medium mb-2">Owner HR Summary</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <K label="Total Karyawan" value={o.total_employees} />
            <K label="Aktif" value={o.active} tone="text-emerald-400" />
            <K label="Nonaktif" value={o.inactive} tone="text-slate-400" />
            <K label="Karyawan Baru (bln ini)" value={o.new_employees_this_month} />
            <K label="Tingkat Kehadiran" value={o.attendance_rate == null ? "—" : `${o.attendance_rate}%`} />
            <K label="Lembur Disetujui (bln ini)" value={o.overtime_approved_this_month} />
            <K label="Biaya Payroll" value={rp(o.payroll_cost)} tone="text-amber-400" />
            <K label="Status Payroll" value={o.payroll_status} />
          </div>
        </Card>
      )}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
        <K label="Karyawan Aktif" value={d.active_employees} />
        <K label="Hadir Hari Ini" value={d.hadir} tone="text-emerald-400" />
        <K label="Terlambat" value={d.terlambat} tone="text-amber-400" />
        <K label="Tidak Hadir" value={d.tidak_hadir} tone="text-rose-400" />
        <K label="Cuti" value={d.cuti} />
        <K label="Izin" value={d.izin} />
        <K label="Sakit" value={d.sakit} />
        <K label="Lembur" value={d.lembur} />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <K label="Pengajuan Cuti/Izin Pending" value={d.leave_pending} tone="text-amber-400" />
        <K label="Lembur Pending" value={d.overtime_pending} tone="text-amber-400" />
        <K label={`Payroll ${p.period}`} value={p.status} />
        <K label="Payroll Menunggu Approval" value={d.payroll_pending_approval} tone="text-amber-400" />
      </div>
    </div>
  );
}
